import { useCallback } from 'react';
import styled from 'styled-components';
import { OBSIDIAN, CALYPSO_LIGHT } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICopyButton from 'UIComponents/button/UICopyButton';
import IconWithClickAnimation from './IconWithClickAnimation';
import { jsx as _jsx } from "react/jsx-runtime";
const CopyIconButton = styled(UICopyButton).withConfig({
  displayName: "CopyMessageActionButton__CopyIconButton",
  componentId: "sc-1ws5apl-0"
})(["&&&{border:none;background:inherit;margin-top:0;margin-left:0;padding-left:0;padding-right:0;text-align:center;text-overflow:clip;&:hover{background:", ";}}&&{font-size:16px;width:32px;}"], CALYPSO_LIGHT);
const CopyMessageActionButton = ({
  message,
  usageTracker
}) => {
  const onCopyButtonClick = useCallback(() => {
    usageTracker.track('copyMessageInteraction', {
      action: 'prompt_copied'
    });
  }, [usageTracker]);
  return /*#__PURE__*/_jsx(CopyIconButton, {
    "data-test-id": "copy-button",
    hint: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "aiComponentsUiLibrary.components.inlineFeedback.copyButton.hint"
    }),
    onClick: onCopyButtonClick,
    tooltipPlacement: "right",
    use: "tertiary-extra-light",
    size: "sm",
    value: message,
    children: /*#__PURE__*/_jsx(IconWithClickAnimation, {
      color: OBSIDIAN,
      name: "clipboard",
      size: "xxs"
    })
  });
};
export default CopyMessageActionButton;